const config = {
  PROXY_URL: process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000/proxy'
    : 'https://cors-anywhere.herokuapp.com',
};

export default config; 